import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const UnderstandPricing: React.FC = () => {
  const content = (
    <>
      <h2>Forstå priser på DoMore</h2>
      <p>
        Priser på DoMore sættes af de individuelle værktøjsejere. Her er hvad du skal vide om, hvordan prissætningen fungerer.
      </p>

      <h3>Pris per dag</h3>
      <p>
        Alt værktøj vises med en pris per dag. Dette er den daglige lejepris som ejeren har sat.
      </p>
      <ul>
        <li>Prisen dækker 24 timers leje</li>
        <li>Første dag tæller fra afhentning til næste dag samme tid</li>
        <li>Efterfølgende dage beregnes på samme måde</li>
      </ul>

      <h3>Hvordan beregnes den totale pris?</h3>
      <p>
        Den totale pris beregnes således:
      </p>
      <code>Total pris = Pris per dag × Antal dage</code>
      <p>
        For eksempel: En boremaskine til 50 kr/dag i 3 dage = 150 kr i alt.
      </p>

      <h3>Hvad er inkluderet i prisen?</h3>
      <p>
        Det afhænger af den enkelte ejer, men typisk inkluderer prisen:
      </p>
      <ul>
        <li>Selve værktøjet</li>
        <li>Standard tilbehør der følger med</li>
        <li>Grundlæggende instruktioner i brug</li>
      </ul>
      <p>
        Spørg altid ejeren hvis du er i tvivl om hvad der er inkluderet.
      </p>

      <h3>Hvad er IKKE inkluderet?</h3>
      <p>
        Følgende er typisk ikke inkluderet:
      </p>
      <ul>
        <li>Forbrugsmaterialer (f.eks. sandpapir, skruer)</li>
        <li>Brændstof eller elektricitet</li>
        <li>Levering (medmindre aftalt)</li>
        <li>Depositum (hvis ejeren kræver det)</li>
      </ul>

      <h3>Rabatter ved længere leje</h3>
      <p>
        Nogle ejere tilbyder rabatter ved længere lejeperioder. Du kan:
      </p>
      <ul>
        <li>Spørge ejeren om rabat for ugentlig eller månedlig leje</li>
        <li>Se efter værktøj der annoncerer rabatter i beskrivelsen</li>
        <li>Forhandle direkte med ejeren via chat</li>
      </ul>

      <h3>Depositum</h3>
      <p>
        Nogle ejere kan kræve et depositum:
      </p>
      <ul>
        <li>Depositum aftales direkte mellem dig og ejeren</li>
        <li>Det returneres efter værktøjet er tjekket ved returnering</li>
        <li>Hvis der er skader, kan depositum bruges til reparation</li>
      </ul>

      <h3>Betaling</h3>
      <p>
        Betaling håndteres direkte mellem lejer og udlejer:
      </p>
      <ul>
        <li>Aftale betalingsmetode (MobilePay, kontant, bankoverførsel)</li>
        <li>Betaling sker typisk ved afhentning eller returnering</li>
        <li>DoMore tager ikke provision af lejen</li>
      </ul>

      <h3>Tips til fair prissætning</h3>
      <p>
        Hvis du selv vil udleje værktøj:
      </p>
      <ul>
        <li>Sammenlign med lignende værktøj på platformen</li>
        <li>Overvej værktøjets værdi og alder</li>
        <li>Husk vedligeholdelsesomkostninger</li>
        <li>Vær konkurrencedygtig men rimelig</li>
      </ul>
    </>
  );

  return (
    <HelpArticle
      title="Forstå priser"
      category="Kom i gang"
      content={content}
      relatedArticles={[
        { title: 'Sådan administrerer du betaling mellem parter', link: '/help/payment-management' },
        { title: 'Foretag din første booking', link: '/help/first-booking' },
      ]}
    />
  );
};

export default UnderstandPricing;
